import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { withSetPropAction } from '../extensions/withSetPropAction';

/**
 * # TimerStore
 * 타이머 상태 관리
 */

const TimerStoreBase = types
  .model('TimerStore')
  .props({
    timeLeft: types.optional(types.number, 300),
    isRunning: types.optional(types.boolean, true),
    isFinished: types.optional(types.boolean, false),
  })
  .volatile(() => ({
    decrementTime: () => {
      // do nothing
    },
    clearTimer: () => {
      // do nothing
    },
    startTimer: () => () => {
      // do nothing
    },
    intervalId: undefined as NodeJS.Timeout | undefined,
  }))
  .views((self) => ({
    get minutes() {
      return String(Math.floor(self.timeLeft / 60)).padStart(2, '0');
    },
    get seconds() {
      return String(self.timeLeft % 60).padStart(2, '0');
    },
  }))
  .actions(withSetPropAction)
  .actions((self) => ({
    decrementTime() {
      self.timeLeft -= 1;
      if (self.timeLeft <= 0) {
        self.isRunning = false;
        self.isFinished = true;
        self.clearTimer();
      }
    },
    pause() {
      if (self.isRunning) {
        self.isRunning = false;
        self.clearTimer();
      }
    },
    reset() {
      self.timeLeft = 300;
      self.isRunning = true;
      self.isFinished = false;
      self.clearTimer();
      self.startTimer();
    },
    startTimer() {
      self.clearTimer();

      if (self.isRunning && self.timeLeft > 0) {
        self.intervalId = setInterval(() => {
          self.decrementTime();
        }, 1000);
      }

      return () => {
        self.clearTimer();
      };
    },
    clearTimer() {
      if (self.intervalId) {
        clearInterval(self.intervalId);
        self.intervalId = undefined;
      }
    },
    clearFinishedState() {
      self.isFinished = false;
    },
  }));

export interface ITimerStore extends Instance<typeof TimerStoreBase> {}
export const TimerStore = TimerStoreBase;
export type TTimerStore = Instance<typeof TimerStore>;
export type TTimerStoreSnapshot = SnapshotOut<typeof TimerStore>;
export const createTimerStore = () => types.optional(TimerStore, {});
